import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { downloadCsv } from "@/lib/csv";
import api from "@/lib/api";
import { PageHeader, label } from "@/components/app/bits";
import { Pager } from "@/pages/app/Changes";

export default function Audit() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(0);
  const LIMIT = 50;
  useEffect(() => { const t = setTimeout(() => api.get("/audit", { params: { q, limit: LIMIT, skip: page * LIMIT } }).then((r) => setData(r.data)), q ? 250 : 0); return () => clearTimeout(t); }, [q, page]);
  useEffect(() => { setPage(0); }, [q]);
  const list = data?.items || [];
  const exportCsv = () => downloadCsv("changeos-audit.csv", [["at", "actor", "action", "detail", "change_id"], ...list.map((a) => [a.at, a.actor, a.action, a.detail, a.change_id || ""])]);
  return (
    <div data-testid="audit-page">
      <PageHeader overline="Compliance" title="Audit trail" sub="Every decision, who made it and when. Filter and export for sign-off."
        action={<button data-testid="audit-export" onClick={exportCsv} className="pp-btn-ghost"><Download size={14} /> Export CSV</button>} />
      <input aria-label="Filter audit entries" data-testid="audit-search" className="pp-input mb-4 max-w-md" placeholder="Filter by person, action or detail" value={q} onChange={(e) => setQ(e.target.value)} />
      <div className="pp-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted text-[11px] uppercase tracking-wide text-muted-foreground"><tr><th scope="col" className="text-left font-bold px-4 py-3">When</th><th scope="col" className="text-left font-bold px-4 py-3">Who</th><th scope="col" className="text-left font-bold px-4 py-3">Action</th><th scope="col" className="text-left font-bold px-4 py-3 hidden md:table-cell">Detail</th></tr></thead>
          <tbody className="divide-y divide-border-soft">
            {list.map((a) => (
              <tr key={a.id} data-testid={`audit-row-${a.id}`} className="hover:bg-muted/60">
                <td className="px-4 py-3 text-muted-foreground whitespace-nowrap font-mono text-xs">{new Date(a.at).toLocaleString("en-AU")}</td>
                <td className="px-4 py-3 font-semibold text-foreground">{a.actor}</td>
                <td className="px-4 py-3 text-body capitalize">{label(a.action)}</td>
                <td className="px-4 py-3 text-muted-foreground hidden md:table-cell">{a.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <div className="p-8 text-center text-sm text-muted-foreground">No audit entries.</div>}
      </div>
      {data && data.total > LIMIT && <Pager page={page} pages={Math.ceil(data.total / LIMIT)} total={data.total} setPage={setPage} />}
    </div>
  );
}
